import CoreBase from '../../../../services/engines/CoreBase';
import templateLoader from './TemplateLoader';

class DataInjector extends CoreBase {
    _name = 'DataInjector';

    /**
     * Loads and parses the layout config note via templateJson.layoutRk.
     * @param {object} templateJson
     * @returns {object} layout config or empty object on failure
     */
    _loadLayoutConfig(templateJson) {
        const note = templateLoader.load(templateJson.layoutRk);
        if (!note) return {};

        try {
            return JSON.parse(note.body);
        } catch (e) {
            this.logError(`_loadLayoutConfig: invalid JSON — ${e.message}`);
            return {};
        }
    }

    /**
     * Injects enriched data, settings and layout config into the HTML shell.
     * @param {string} html
     * @param {object} templateJson
     * @param {object} enriched
     * @param {object} settings
     * @returns {string} html with data injected
     */
    inject(html, templateJson, enriched, settings) {
        const layoutConfig = this._loadLayoutConfig(templateJson);

        this.logDebug('inject', `layoutConfig: ${JSON.stringify(layoutConfig)}`);

        html = html.replace(/const data = \{[\s\S]*?\};/, `const data = ${JSON.stringify(enriched, null, 2)};`);

        html = html.replace(/const settings = \{[\s\S]*?\};/, `const settings = ${JSON.stringify(settings, null, 2)};`);

        html = html.replace(/const layoutConfig = \{[\s\S]*?\};/, `const layoutConfig = ${JSON.stringify(layoutConfig)};`);

        // Inject layoutRk als meta tag — gebruikt door saveLayoutConfig in iframe
        html = html.replace(
            '<meta charset="UTF-8">',
            `<meta charset="UTF-8"><meta name="layout-config-rk" content="${templateJson.layoutRk}">`,
        );

        return html;
    }
}

const dataInjector = new DataInjector();
export default dataInjector;
